import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  createExternalRouteRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { toolsRegistryApiRef } from './api/ToolsRegistryApi';
import { ToolsRegistryClient } from './api/ToolsRegistryClient';

/** External route refs — resolved at app-level via bindRoutes */
export const agentRegistryExternalRouteRef = createExternalRouteRef({
  id: 'agent-registry',
});

export const workflowComposerExternalRouteRef = createExternalRouteRef({
  id: 'workflow-composer',
});

export const toolsRegistryPlugin = createPlugin({
  id: 'tools-registry',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    agentRegistry: agentRegistryExternalRouteRef,
    workflowComposer: workflowComposerExternalRouteRef,
  },
  apis: [
    createApiFactory({
      api: toolsRegistryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ToolsRegistryClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ToolsRegistryPage = toolsRegistryPlugin.provide(
  createRoutableExtension({
    name: 'ToolsRegistryPage',
    component: () =>
      import('./components/ToolsRegistryPage').then(m => m.ToolsRegistryPage) as any,
    mountPoint: rootRouteRef,
  }),
);
